<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('bill_payments.create')" @invoke-method="invokeMethod($event)" action="openBillPaymentForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetBillPayments(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="bill_payments" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openBillPaymentForm(props.item)">
                                <td>{{ props.item.payment_id }}</td>
                                <td>{{ props.item.bill_id }}</td>
                                <td>{{ props.item.company }}</td>
                                <td>{{ props.item.payment_date }}</td>
                                <td>{{ props.item.amount }}</td>
                                <td>{{ props.item.payment_method }}</td>
                                <td>
                                    <v-chip disabled round text-color="white" class="fs-14 text-center" :color="props.item.status_class">
                                        <span style="min-width: 60px">{{ props.item.payment_status }}</span>
                                    </v-chip>
                                </td>
                                <td>{{ props.item.reference_number }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="bill_payments"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="bill_payment_dialog">
                <v-card>
                    <v-form ref="form_bill_payment">
                        <v-card-title>
                            <span class="headline">{{ bill_payment.payment_id ? $t("lang.edit_bill_payment") : $t("lang.add_bill_payment") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeBillPaymentDialog"
                                :dialog-status="bill_payment_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="bill_payment.bill_id"
                                            :label="$t('lang.bill_id')"
                                            :items="bills"
                                            item-value="bill_id"
                                            item-text="bill_id"
                                            :rules="ifValid('bill_payments.bill_id')"
                                            @change="setupBillAmount(bill_payment.bill_id)"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="bill_payment.payment_date"
                                            :label="$t('lang.payment_date')"
                                            :rules="ifValid('bill_payments.payment_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill_payment.amount"
                                            :label="$t('lang.amount')"
                                            :counter="showCounter(bill_payment.amount, 'bill_payments.amount')"
                                            :rules="ifValid('bill_payments.amount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <!-- <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="bill_payment.currency_id"
                                            :label="$t('lang.currency_id')"
                                            :items="currencies"
                                            item-value="currency_id"
                                            item-text="name"
                                            :rules="ifValid('bill_payments.currency_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill_payment.exchange_rate"
                                            :label="$t('lang.exchange_rate')"
                                            :counter="showCounter(bill_payment.exchange_rate, 'bill_payments.exchange_rate')"
                                            :rules="ifValid('bill_payments.exchange_rate')"
                                        ></v-text-field>
                                    </v-flex> -->
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="bill_payment.payment_method_id"
                                            :label="`${$t('lang.payment_method_id')} *`"
                                            :items="payment_methods"
                                            item-value="option_id"
                                            item-text="option"
                                            :rules="ifValid('bill_payments.payment_method_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="bill_payment.payment_status_id"
                                            :label="`${$t('lang.payment_status_id')} *`"
                                            :items="payment_status"
                                            item-value="option_id"
                                            item-text="option"
                                            :rules="ifValid('bill_payments.payment_status_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill_payment.reference_number"
                                            :label="$t('lang.reference_number')"
                                            :counter="showCounter(bill_payment.reference_number, 'bill_payments.reference_number')"
                                            :rules="ifValid('bill_payments.reference_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill_payment.notes"
                                            :label="$t('lang.notes')"
                                            :counter="showCounter(bill_payment.notes, 'bill_payments.notes')"
                                            :rules="ifValid('bill_payments.notes')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="bill_payment.payment_id" color="error" @mouseup.left="$refs.delete_bill_payments.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeBillPaymentDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveBillPayments">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_bill_payments"
                :heading="$t('lang.delete_bill_payment')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteBillPayments(bill_payment.payment_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openBillPaymentForm" },
                { title: this.$t("lang.refresh"), action: "dbGetBillPayments", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.payment_id"), sortable: false, width: "9%" },
                { text: this.$t("lang.bill_id"), sortable: false, width: "9%" },
                { text: this.$t("lang.company"), sortable: false, width: "9%" },
                { text: this.$t("lang.payment_date"), sortable: false, width: "9%" },
                { text: this.$t("lang.amount"), sortable: false, width: "9%" },
                { text: this.$t("lang.payment_method"), sortable: false, width: "9%" },
                { text: this.$t("lang.payment_status"), sortable: false, width: "9%" },
                { text: this.$t("lang.reference_number"), sortable: false, width: "9%" },
            ],
            enableAddModal: true,
            enableEditModal: true,
            customers: null,
            bill_payment: {
                payment_date: new Date().toISOString().substr(0, 10),
                amount: "0.000",
                currency_id: "1",
                exchange_rate: "1.000",
                payment_method_id: "68",
                payment_status_id: "143",
            },
            filter: {
                search: "",
                status: "1",
                company_id: "",
            },
            bill_payment_dialog: false,
            dbGetBillPayments: _.debounce(this.getBillPayments, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchBillPayments", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.bill_payments) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.refresh();
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchBillPayments({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.bill_payments) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.refresh();
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.bill_payments.bill_payments_filter,
            page: (state) => state.bill_payments.page,
            rules_bill_payments: (state) => state.bill_payments.rules_bill_payments,
            bill_payment_status_options: (state) => state.settings.bill_payment_status_options,
            bill_payments: (state) => state.bill_payments.bill_payments,
            payment_methods: (state) => state.options_categories.payment_methods,
            payment_status: (state) => state.options_categories.payment_status,
            currencies: (state) => state.currencies.currencies,
            bills: (state) => state.bills.bills,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchBillPayments", "saveBillPayment", "deleteBillPayment", "fetchOptions", "fetchVendors", "fetchCurrencies", "fetchBills"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openBillPaymentForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_bill_payment) item ? this.$refs.form_bill_payment.resetValidation() : this.$refs.form_bill_payment.reset();

                    this.$nextTick(() => {
                        this.bill_payment = item != null ? this.assignObj2(item, this.rules_bill_payments) : {};
                        this.bill_payment_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "bill_payment", params: { id: item.payment_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_bill_payment) item ? this.$refs.form_bill_payment.resetValidation() : this.$refs.form_bill_payment.reset();
                    this.bill_payment_dialog = true;
                } else {
                    this.$router.push({ name: "bill_payment" });
                }
            }
        },
        saveBillPayments() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_bill_payment")) {
                    let body = this.prepForm(this.bill_payment, this.rules_bill_payments);

                    this.saveBillPayment({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getBillPayments();
                                this.closeBillPaymentDialog();
                            } else {
                                this.$router.push({ name: "bill_payment", params: { id: data.payment_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteBillPayments(id = null) {
            this.deleteBillPayment({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getBillPayments();
                    this.closeBillPaymentDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeBillPaymentDialog() {
            this.bill_payment_dialog = false;
            this.$refs.delete_bill_payments.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getBillPayments(pg_refresh = false) {
            this.startLoader();

            this.fetchBillPayments({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.bill_payment_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        setupBillAmount(bill_id) {
            let bill = this.bills.find((bill) => bill.bill_id == bill_id);
            if (bill) {
                this.bill_payment.amount = bill.balance;
            }
        },
        async refresh(force = false) {
            this.startLoader();

            if (this.bills.length == 0 || force == true) await this.fetchBills({ body: { options: 1, status: "open" } });
            if (this.currencies.length == 0 || force == true) await this.fetchCurrencies({ body: { options: 1 } });
            if (this.payment_methods == 0 || force == true) await this.fetchOptions({ body: { slug: "payment_methods", sort_by: "0", options: 1 } });
            if (this.payment_status == 0 || force == true) await this.fetchOptions({ body: { slug: "payment_status", sort_by: "0", options: 1 } });

            this.finishLoader();
        },
    },
};
</script>
